import React, { Component } from "react";
import BsyDashboardAppMenu from "../BsyDashboardAppMenu";

import BsySearchResult from "../../BsySearchResult";
import BsyMsgBubble from "../../BsyMsgBubble";
import BsyAlertMenu from "../../BsyAlertMenu";

import { BsyUtils } from "../../../utils/Utils";

import "./index.css";
import { withRouter } from "react-router-dom";
import { BsyConfig } from "../../../global/BsyConfig";

import BsySystemRightMenu from "../../BsySystemRightMenu";
import BsySystemLeftMenu from "../../BsySystemLeftMenu";
import { createTooltip } from "../../../utils/createTooltip";

class BsyDashboardMenu extends Component {
  static defaultProps = {
    appEmpty: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      teamName: "",
      virtualType: props.virtualType,
      noticeinfo: [],
      haveNews: false,
      appsCache: props.appsCache,
      apps: props.apps,
      appid: props.appid,
      dockItem: props.dockItem,
      dockCorp: props.dockCorp,
      entryid: props.entryid,
      type: props.type,
      routePath: props.routePath || props.match.path,
      components: props.components,
      appEmpty: props.appEmpty,
      selectDesignId: "",
      designList: [],
      use_custom_dash: false,
      custom_dash: false,
      showSearch: false,
      hasDesign: ["/team/standard/:type", "/open/api"].includes(
        props.routePath || props.match.path
      )
        ? false
        : true,
    };
  }

  componentDidMount = () => {
    this.getTeamName();
    this.props && this.props.getContext && this.props.getContext(this);
    this._getMsgUnread();
    this._getDesignList();
    const { show, hide } = createTooltip();
    this.showTooltip = show;
    this.hideTooltip = hide;
  };

  componentWillUnmount() {
    this.hideTooltip();
  }

  _getDesignList = () => {
    React.axios("/corp/custom_config").then((res) => {
      this.setState({
        hasCustom: res.data.hasCustom,
        designList: res.data.dashlist,
        use_custom_dash: res.data.use_custom_dash,
        custom_dash: res.data.custom_dash,
      });
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const { appid, type, entryid, groupid } = nextProps.match.params;
    const { apps } = this.state;

    const ppp = {
      ...this.state,
      ...nextProps,
      appid: appid,
      type: type,
      routePath: nextProps.routePath || nextProps.match.path,
      entryid: entryid,
      groupid: groupid,
      appsCache: nextProps.appsCache,
      appEmpty: nextProps.appEmpty,
    };
    this.setState(ppp);
  }

  getTeamName = () => {
    let teamName = "";
    window?.localDevInfo?.corps.map((data) => {
      if (data.id === window.FX.STATIC.corpId) {
        teamName = data.name;
      }
      return true;
    });
    this.setState({
      teamName: teamName,
    });
  };

  getAppMenuContext = (context) => {
    this.AppMenuContext = context;
  };

  selectApp = (appinfo) => {
    this.AppMenuContext.selectApp(appinfo);

    if (this.BubbleHnadle) {
      this.BubbleHnadle.onRemoveRoot();
      this.BubbleHnadle = null;
    }
  };

  BsyBubbleContext = (context) => {
    this.BubbleHnadle = context;
  };

  onAllApp = () => {
    this.props.onAllApp && this.props.onAllApp();
  };

  save = (components) => {
    if (this.props.onSave) {
      this.props.onSave(components);
      this.setState(components);
    }
    if (this.BsySlideContext) {
      this.BsySlideContext.onRemoveRoot();
      this.BsySlideContext = null;
    }
  };

  // onSelectApp = (appinfo) => {
  //     if (this.props.onSelectApp) {
  //         this.props.onSelectApp(appinfo)
  //     }
  // }

  getContext = (context) => {
    this.BsySlideContext = context;
  };

  getDesignContext = (context) => {
    this.BsyDesignContext = context;
  };

  eventCustMent = (node) => {
    React.axios("/corp/custom_config", {
      id: node.id,
    })
      .then((res) => {
        window.location.reload();
      })
      .catch((res) => {
        console.error(res);
      });
  };

  dashboardDesign = (e) => {
    e.stopPropagation();
    const { designList, use_custom_dash, custom_dash } = this.state;
    let menu = [];
    if (!use_custom_dash) {
      let item = {
        text: "选择工作台",
        itemHeight: 36,
        colorType: "",
        customCls: "dashboard-work-space-title",
        click: () => {},
      };
      menu.push(item);

      const fistr = designList.find((res, key) => {
        return !res.editEnable;
      });

      if (fistr) {
        let item = {
          text: fistr.name,
          afterText: React.language("default"),
          afterTextColor: "#4D609F",
          itemHeight: 36,
          selected: fistr.select,
          extIcon: fistr.select ? "icon-ok" : "",
          extIconColor: "#0265ff",
          colorType: "",

          click: () => {
            this.eventCustMent(fistr);
          },
        };
        menu.push(item);

        if (designList.length === 1) {
          menu.push({
            line: true,
          });
        }
      }

      // eslint-disable-next-line array-callback-return
      let list = designList.filter((res) => res.editEnable);
      list.map((res, key) => {
        let item = {
          text: res.name,
          afterText: !res.editEnable ? React.language("default") : "",
          afterTextColor: "#4D609F",
          itemHeight: 36,
          selected: res.select,
          extIcon: res.select ? "icon-ok" : "",
          extIconColor: "#0265ff",
          colorType: "",

          click: () => {
            this.eventCustMent(res);
          },
        };
        menu.push(item);
        return null;
      });

      if (list.length > 0) {
        menu.push({
          line: true,
        });
      }
    }

    if (BsyUtils.isCorpOwn() || BsyUtils.isSysManager()) {
      menu.push({
        text: React.language("set.worker.dashboard.design"),
        itemHeight: 36,
        colorType: "",
        icon: "icon-all-corp",
        iconColor: "#0265ff",
        click: () => {
          this.showDesignPane("company");
        },
      });
    }

    if (custom_dash) {
      menu.push({
        text: React.language("dash.design.custom"),
        colorType: "",
        itemHeight: 36,
        icon: "icon-bsy-mydesign",
        iconColor: "#0265ff",
        click: () => {
          this.showDesignPane("custom");
        },
      });
    }
    const icon = e.currentTarget.querySelector("i");

    icon.classList.add("icon-up1");
    icon.classList.remove("icon-down1");
    BsyAlertMenu({
      item: menu,
      width: 230,
      theme: "work-type",
      target: e.currentTarget,
      onClose: (e) => {
        icon.classList.add("icon-down1");
        icon.classList.remove("icon-up1");
        // e.stopPropagation();
        return !0;
      },
    });
  };

  showDesignPane = (type) => {
    const { components } = this.state;
    this.props.history.push(`/dashboard/desing/${type}`);
    // BsySlidePane({
    //     title: React.language('dash.design.' + type),
    //     customCls: 'dashboard-desing',
    //     getContext: this.getContext,
    //     onHeaderMenu: () => {
    //         return <div style={{ display: type === 'custom' ? 'none' : 'block' }} className='btns'>
    //             {type === 'custom' && <BsyIconBtn
    //                 text={React.language('close.custom.dash')}
    //                 type="white"
    //                 click={() => {
    //                     BsyAlert({
    //                         title: React.language("design.close.alert.title"),
    //                         msg: React.language("design.close.alert.msg"),
    //                         type: "warning",
    //                         text4Ok: React.language("ok"),
    //                         OkType: "red",
    //                         text4Cancel: React.language("cancel"),
    //                         ok: () => {
    //                             this.BsyDesignContext.onSave('close')
    //                         }
    //                     })
    //                 }}
    //                 mode={window.mode}
    //             />}
    //             <BsyIconBtn
    //                 text={React.language('save')}
    //                 type="blue"
    //                 click={() => { this.BsyDesignContext.onSave() }}
    //                 mode={window.mode}
    //             />
    //         </div>
    //     },
    //     onContentCreate: () => {
    //         return <BrowserRouter><BsyDashboardDesign
    //             getContext={this.getDesignContext}
    //             onSave={
    //                 this.save
    //             }
    //             dockItem={this.state.dockItem}
    //             dockCorp={this.state.dockCorp}
    //             components={components}
    //             designType={type}
    //         /></BrowserRouter>
    //     },
    // })
  };

  userMananger = () => {
    window.location.href =
      "/corp/addressbook?referer_uri=" + window.location.href;
    // BsySlidePane({
    //     title: React.language('contacts'),
    //     hasHeader: false,
    //     onContentCreate: (ref) => {
    //         return <BsyAddressbook alertDom={ref} />
    //     },
    // })
  };

  seachOpen = (event) => {
    const el = event.currentTarget.parentNode;
    setTimeout(() => {
      el.getElementsByTagName("input")[0].focus();
    }, 30);
    this.setState({
      seach: true,
    });
  };

  onBlur = () => {
    this.setState({
      seach: false,
    });
  };

  createUpDateTip = (c) => {
    let noticeinfo = c ? c.noticeinfo : this.state.noticeinfo;
    if (
      BsyUtils.isObjectEmpty(noticeinfo) ||
      window.$(".bsy-update-tip").length > 0
    ) {
      return;
    }
    let updateTip = window
      .$("<div class='bsy-update-tip' />")
      .css({ "z-index": window.FX.STATIC.zIndex++ })
      .appendTo(window.$("body"));
    let strKey = "bbynotice_" + noticeinfo.cookie_str;
    window
      .$("<div class='update-title' />")
      .append(window.$("<span />").text(noticeinfo.title))
      .append(
        window.$("<i class='icon icon-bsy-close' />").on("click", function () {
          const closeTime = Math.ceil(new Date().getTime() / 1000);
          const endTime = noticeinfo.endtime - closeTime;
          updateTip.animate({ right: -updateTip.width() + "px" }, 0);
          setTimeout(function () {
            updateTip.remove();
          }, 500);
          endTime > 0 &&
            window.FX.Cookie.set(strKey, closeTime, {
              expires: new Date(noticeinfo.endtime * 1000),
              path: "/",
            });
        })
      )
      .appendTo(updateTip);
    window
      .$("<div class='update-cont' />")
      .append(window.$("<span />").text(noticeinfo.content))
      .appendTo(updateTip);
    window
      .$("<div class='update-btn' />")
      .append(
        window
          .$("<a />")
          .on("click", function () {
            const closeTime = Math.ceil(new Date().getTime() / 1000);
            const endTime = noticeinfo.endtime - closeTime;
            window.FX.Utils.redirectTo(noticeinfo.link, "_blank");
            endTime > 0 &&
              window.FX.Cookie.set(strKey, closeTime, {
                expires: new Date(noticeinfo.endtime * 1000),
                path: "/",
              });
          })
          .text(React.language("view.detail"))
      )
      .appendTo(updateTip);
  };

  openMessage = (event) => {
    const _this = this;
    new window.FX.Slider({
      title: React.language("message.center"),
      contentWidget: {
        type: "messagecenter",
      },
      onClose: function () {
        _this._getMsgUnread(function (e) {
          if (e.count > 0) {
            _this.setState({ haveNews: true });
          } else {
            _this.setState({ haveNews: false });
          }
        });
      },
    }).show();
  };

  _getMsgUnread = (cb) => {
    let b = this;
    window.FX.Utils.ajax(
      {
        url: "/message/unread",
      },
      function (d) {
        b.setState(
          {
            haveNews: d.count > 0,
            noticeinfo: d.noticeinfo,
          },
          () => {
            b.noticeinfo = d.noticeinfo;
            b.createUpDateTip(d);
            cb && cb(d);
          }
        );
      }
    );
  };

  exprotOpen = () => {
    new window.FX.Slider({
      title: React.language("export.management"),
      contentWidget: {
        type: "formexportpane",
      },
      onClose: function () {
        clearTimeout(window.eventid);
      },
    }).show();
  };

  openBrowser = () => {
    var url = window.location.href;
    window.FX.Utils.dataAjax(
      {
        url: "/sso/getJumpUrl",
        data: {
          url: url,
        },
      },
      function (data) {
        if (window.wx) {
          window.wx.invoke(
            "openDefaultBrowser",
            {
              url: data.url, // 在默认浏览器打开redirect_uri，并附加code参数；也可以直接指定要打开的url，此时不会附带上code参数。
            },
            function (res) {
              if (res.err_msg != "openDefaultBrowser:ok") {
                //错误处理
              }
            }
          );
        } else {
          window.open(data.url);
        }
      },
      null
    );
  };

  _switch_corp = (corpId) => {
    return () => {
      window.FX.Utils.ajax(
        {
          url: "/dashboard/switch_corp",
          data: {
            corpId: corpId,
          },
        },
        function (d, e) {
          window.location.href = window.rootDirectroy + "/";
        }
      );
    };
  };

  changeTeam = (event) => {
    if (
      window.FX.Utils.isQyWinxin() ||
      window.FX.Utils.isDingding() ||
      window.FX.Utils.isFeishu() ||
      window.FX.STATIC.user.acctype === "webapi"
    ) {
      //优化 上诉模式 只有一个团队时 返回 多个可以切换 外部联系人的情况zhxj210916
      if (window?.localDevInfo?.corps.length < 2) {
        return;
      }
    }

    const currteam = BsyUtils._getTeamName(window.FX.STATIC.user.corpId);
    BsyMsgBubble({
      anchor: event.currentTarget,
      customCls: "change-team-bubble",
      contentHTML: () => {
        return (
          <div className="bby-team-center">
            <div>
              <div>
                <div className="team-title">
                  <i className="icon-team-join" />
                  <span>{React.language("corp.owned")}</span>
                </div>
                <div className="split-line"></div>
                <ul className="menu-team">
                  <li
                    className={
                      "menu-item " +
                      (window.FX.STATIC.corpId === window.FX.STATIC.user.corpId
                        ? "select"
                        : "")
                    }
                    onClick={this._switch_corp(window.FX.STATIC.user.corpId)}
                    role={window.FX.STATIC.user.corpId}
                    title={currteam}
                  >
                    <span>{currteam}</span>
                  </li>
                </ul>
              </div>
              <div>
                <div className="team-title">
                  <i className="icon-new-tuandui" />
                  <span>{React.language("corp.joined")}</span>
                </div>
                <div className="split-line"></div>
                <div className="teamRoll">
                  <ul className="menu-team">
                    {window?.localDevInfo?.corps.map((val) => {
                      return (
                        window.FX.STATIC.user.corpId !== val.id && (
                          <li
                            className={
                              "menu-item " +
                              (window.FX.STATIC.corpId === val.id
                                ? "select"
                                : "")
                            }
                            onClick={this._switch_corp(val.id)}
                            role={val.id}
                            title={val.name}
                          >
                            <span>{val.name}</span>
                          </li>
                        )
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        );
      },
      text4Cancel: null,
      text4Ok: null,
      minWidth: 320,
      width: 320,
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "left",
      // "marginTop":20,
      onClose: function () {
        return !1;
      },
    });
  };

  toTarget = (app, n, s) => {
    this.setState(
      {
        seach: false,
      },
      () => {
        if (app.type === "app") {
          let appCache = BsyUtils.getEntryCache(app._id);
          if (BsyUtils.isObjectEmpty(appCache)) {
            this.props.history.push(
              window.rootDirectroy + "/team/app/" + app._id
            );
          } else {
            this.props.history.push(
              `${window.rootDirectroy}/team/app/${appCache.appid}/${appCache.type}/${appCache.entryid}`
            );
          }

          // this.props.history.push(`/team/app/${app._id}`)
        } else {
          this.props.history.push(
            `${window.rootDirectroy}/team/app/${app.appId}/${app.type}/${app.entryId}`
          );
        }
        s && s.closeAlter();
        window.location.reload();
      }
    );
  };

  appSearch = () => {
    let dd = this;
    const { searchValue } = this.state;
    return (
      <BsySearchResult
        // items={items}
        autoClose={false}
        dockPosition="center"
        async={{
          url: "/dashboard/search",
          data: {
            type: "all",
            mode: "all",
            range: this.props.isStandard ? "standard" : "noStandard",
          },
          sucess: (items) => {
            return items.list;
          },
        }}
        // inputValue={searchValue}
        minHeight={100}
        maxHeight={350}
        width={190}
        onBlur={(e) => {
          setTimeout(function () {
            dd.setState({
              seach: false,
            });
          }, 300);
        }}
        placeholder={React.language("searchApp")}
        onCreatResult={(res, s) => {
          let appItem = [];
          let otherItem = [];
          if (res && res.length > 0) {
            res.map((val) => {
              if (val.type !== "app") {
                otherItem.push(val);
              } else {
                appItem.push(val);
              }
            });
          }
          return res && res.length > 0 ? (
            <div className="searchAllAppFormReport">
              <ul className="searchFormDashReport">
                {otherItem.length > 0 ? (
                  otherItem.map((val) => {
                    return (
                      val && (
                        <li
                          key={val.id}
                          onClick={(e) => {
                            this.toTarget(val, null, s);
                          }}
                        >
                          <div className="contView">
                            <div className="menu-item" title={val.text}>
                              <i
                                className={`node-icon icon-bsy-${val.type}${
                                  !val.hasCoop ? "-flow" : ""
                                } icon-bsy-form-${val.icon}`}
                              />
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: val.titleHtml,
                                }}
                              />
                            </div>
                            <div className="appNameItem">
                              <span>{val.appName}</span>
                            </div>
                            {val.mode === "dock" && (
                              <div
                                className="dockItem"
                                title={
                                  React.language("organization.external") +
                                  ":" +
                                  val.corp_name
                                }
                              >
                                {React.language("organization.external") +
                                  ":" +
                                  val.corp_name}
                              </div>
                            )}
                          </div>
                        </li>
                      )
                    );
                  })
                ) : (
                  <li className="emptySearchForm">
                    {React.language("dash.form.empty")}
                  </li>
                )}
              </ul>
              <ul className="searchApp dock">
                {appItem.length > 0 ? (
                  appItem.map((val) => {
                    return (
                      val && (
                        <li
                          key={val.id}
                          onClick={(e) => {
                            this.toTarget(val, "isApp", s);
                          }}
                        >
                          <div className="appItem">
                            <div
                              className={
                                "app-icon color-cover-" + val.style.color
                              }
                            >
                              <div
                                className={
                                  "imgbg-small-bsy-app imgbg-bsy-app-" +
                                  val.style.icon
                                }
                              />
                            </div>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: val.titleHtml,
                              }}
                            />
                          </div>
                          {val.mode === "dock" && (
                            <div
                              className="dockItem"
                              title={
                                React.language("organization.external") +
                                ":" +
                                val.corp_name
                              }
                            >
                              {React.language("organization.external") +
                                ":" +
                                val.corp_name}
                            </div>
                          )}
                        </li>
                      )
                    );
                  })
                ) : (
                  <li className="emptySearchForm">
                    {React.language("app.all.empty")}
                  </li>
                )}
              </ul>
            </div>
          ) : (
            <div className="emptySearchAll">
              {React.language("field.location.empty")}
            </div>
          );
        }}
      />
    );
  };

  //搜索部分
  rednerSeachApp = () => {
    const { routePath, seach, designList, hasDesign } = this.state;
    let sName = "";
    designList &&
      designList.map((res) => {
        if (res.select) {
          sName = res.name;
        }
        return !1;
      });
    switch (routePath) {
      case BsyConfig().RouteEnum.RouteR2:
      case BsyConfig().RouteEnum.RouteR3:
      case BsyConfig().RouteEnum.RouteR4:
      case BsyConfig().RouteEnum.RouteR5: {
        return (
          <>
            <div className="app-seach">{this.appSearch()}</div>
          </>
        );
      }
      default: {
        return (
          <>
            {hasDesign && (
              <>
                {!seach && (
                  <div
                    className="dashboard-design"
                    title={sName ? sName : React.language("dash.custom")}
                    onClick={this.dashboardDesign}
                  >
                    {sName ? sName : ""}
                  </div>
                )}
                <div className="app-seach">
                  {seach ? (
                    this.appSearch()
                  ) : (
                    <i
                      className={"singe icon-bsy-reportmenu-0"}
                      onClick={this.seachOpen}
                    />
                  )}
                </div>
              </>
            )}
            {this.props.isStandard && (
              <div className="app-seach">{this.appSearch()}</div>
            )}
          </>
        );
      }
    }
  };

  toHome = () => {
    window.FX.STATIC.APPID = null;
    window.FX.STATIC.ENTRYID = null;
    window.$(".bsy-form-menu-tree").sortable("destroy");
    window.FX.UI.closePopover();
  };

  switchVirtualType = (t) => {
    return () => {
      this.setState({ virtualType: t }, () => {
        this.props.switchVirtualType && this.props.switchVirtualType(t);
      });
    };
  };

  onShowSearch = (status) => {
    this.setState({ showSearch: status, hasDesign: !status });
  };

  renderContent = () => {
    const {
      teamName,
      designList,
      appid,
      routePath,
      apps,
      virtualType,
      appsCache,
      entryid,
      type,
      showSearch,
      hasDesign,
      hasCustom,
    } = this.state;
    let appItem = {};
    apps &&
      apps.map((res) => {
        res.apps.map((res1) => {
          if (res1._id === appid) {
            appItem = res1;
          }
          return null;
        });
        return null;
      });

    let sName = "";
    designList &&
      designList.map((res) => {
        if (res.select) {
          sName = res.name;
        }
        return !1;
      });

    switch (routePath) {
      case BsyConfig().RouteEnum.RouteR9:
      case BsyConfig().RouteEnum.RouteR10: //数据内链
      case BsyConfig().RouteEnum.RouteR6: //流程消息
      case BsyConfig().RouteEnum.RouteR7: //数据提交消息
      case BsyConfig().RouteEnum.RouteR12: //表单数据管理
      case BsyConfig().RouteEnum.RouteR13: //表单数据管理
      case window.BsyConfig.RouteEnum.TEAMTODO:
      case window.BsyConfig.RouteEnum.TEAMCC:
      case window.BsyConfig.RouteEnum.TEAMTRANSACTORS:
      case window.BsyConfig.RouteEnum.TEAMCREATE:
      case window.BsyConfig.RouteEnum.TEAMLAUNCH:
        return <></>;
      case "/open/api":
      case "/open/key":
      case "/open/modules":
      case "/open/webhook":
      case "/open/sso":
      case "/open/mymodules":
        return (
          <div className={"bsy-menu-pane"}>
            {
              <BsySystemLeftMenu
                backTitle={React.language("dashboard")}
                onRenderTitle={() => (
                  <div className={"left-title  "}>
                    <span className="team-name">
                      {React.language("open.platform")}
                    </span>
                  </div>
                )}
              />
            }
            {this.props.dashboardMenuCenterMenu || appItem.appType === 3 ? (
              <div
                className={"center-menu"}
                style={
                  appItem.appType === 3
                    ? {
                        position: "absolute",
                        left: 0,
                        right: 0,
                        "justify-content": "center",
                      }
                    : {
                        margin: this.props.dashboardMenuCenterMenu
                          ? "0 auto"
                          : "0",
                      }
                }
              >
                {appItem.appType === 3 ? (
                  <div className="virtual-menu">
                    <div
                      className={`menu-item ${
                        virtualType === 1 ? "select" : ""
                      }`}
                      onClick={this.switchVirtualType(1)}
                    >
                      {React.language("test.app.edit")}
                    </div>
                    <div
                      className={`menu-item ${
                        virtualType === 2 ? "select" : ""
                      }`}
                      onClick={this.switchVirtualType(2)}
                    >
                      {React.language("virtual.address.book")}
                    </div>
                  </div>
                ) : this.props.dashboardMenuCenterMenu ? (
                  this.props.dashboardMenuCenterMenu()
                ) : (
                  <>
                    {/* <div className="nav-split" /> */}
                    <BsyDashboardAppMenu
                      getContext={this.getAppMenuContext}
                      appsCache={appsCache}
                      apps={apps}
                      appid={appid}
                      entryid={entryid}
                      type={type}
                      routePath={routePath}
                      // onAllApp={this.onAllApp}
                    />
                  </>
                )}
              </div>
            ) : (
              ""
            )}

            <div className={"right-menu"}>
              <BsySystemRightMenu
                search={false}
                showSearch={showSearch}
                onShowSearch={this.onShowSearch}
              />
            </div>
          </div>
        );

      default:
        return (
          <div className={"bsy-menu-pane"}>
            {
              <BsySystemLeftMenu
                backTitle={React.language("dashboard")}
                onRenderTitle={() => (
                  <div
                    className={
                      "left-title " + (this.props.isStandard ? "" : "clickable")
                    }
                    onClick={
                      this.props.isStandard ? undefined : this.changeTeam
                    }
                  >
                    <span className="team-name">
                      {this.props.isStandard
                        ? React.language("standard.application")
                        : teamName}
                    </span>
                  </div>
                )}
              />
            }
            {this.props.dashboardMenuCenterMenu || appItem.appType === 3 ? (
              <div
                className={"center-menu"}
                style={
                  appItem.appType === 3
                    ? {
                        position: "absolute",
                        left: 0,
                        right: 0,
                        "justify-content": "center",
                      }
                    : {
                        margin: this.props.dashboardMenuCenterMenu
                          ? "0 auto"
                          : "0",
                      }
                }
              >
                {appItem.appType === 3 ? (
                  <div className="virtual-menu">
                    <div
                      className={`menu-item ${
                        virtualType === 1 ? "select" : ""
                      }`}
                      onClick={this.switchVirtualType(1)}
                    >
                      {React.language("test.app.edit")}
                    </div>
                    <div
                      className={`menu-item ${
                        virtualType === 2 ? "select" : ""
                      }`}
                      onClick={this.switchVirtualType(2)}
                    >
                      {React.language("virtual.address.book")}
                    </div>
                  </div>
                ) : this.props.dashboardMenuCenterMenu ? (
                  this.props.dashboardMenuCenterMenu()
                ) : (
                  <>
                    {/* <div className="nav-split" /> */}
                    <BsyDashboardAppMenu
                      getContext={this.getAppMenuContext}
                      appsCache={appsCache}
                      apps={apps}
                      appid={appid}
                      entryid={entryid}
                      type={type}
                      routePath={routePath}
                      // onAllApp={this.onAllApp}
                    />
                  </>
                )}
              </div>
            ) : (
              ""
            )}

            <div className={"right-menu"}>
              {hasDesign && (
                <>
                  {
                    <div
                      className="dashboard-design"
                      title={
                        sName
                          ? sName
                          : hasCustom
                          ? React.language("dash.custom")
                          : ""
                      }
                      onClick={this.dashboardDesign}
                    >
                      <span
                        style={{
                          marginRight: 6,
                        }}
                      >
                        {sName
                          ? sName
                          : hasCustom
                          ? React.language("dash.custom")
                          : ""}
                      </span>
                      {sName || hasCustom ? (
                        <i className="icon-down1" style={{ color: "#666" }}></i>
                      ) : (
                        ""
                      )}
                    </div>
                  }
                </>
              )}
              <BsySystemRightMenu
                search={
                  [
                    "/open/api",
                    "/open/key",
                    "/open/modules",
                    "/open/webhook",
                    "/open/sso",
                    "/open/mymodules",
                  ].includes(this.props.routePath || this.props.match.path)
                    ? false
                    : true
                }
                isStandard={["/team/standard/:type"].includes(
                  this.props.routePath || this.props.match.path
                )}
                showSearch={showSearch}
                onShowSearch={this.onShowSearch}
              />
            </div>
          </div>
        );
    }
  };

  render() {
    return this.renderContent();
  }
}

export default withRouter(BsyDashboardMenu);
